<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">
<template>
  <v-container>
    <v-btn @click="pay()"> Оплатить </v-btn>
    <!--Контейнер, в котором будет отображаться платежная форма-->
    <div id="payment"></div>

    <p>Данные банковской карты для оплаты в <b>тестовом магазине</b>:</p>
    <ul>
      <li>номер — <b>5555 5555 5555 4477</b></li>
      <li>срок действия — <b>01/30</b> (или другая дата, больше текущей)</li>
      <li>CVC — <b>123</b> (или три любые цифры)</li>
      <li>код для прохождения 3-D Secure — <b>123</b> (или три любые цифры)</li>
    </ul>
  </v-container>
</template>


<script>
export default {
  data: () => ({}),

  methods: {
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    async pay() {
      window.open("https://google.com/", "_blank");
    },
  },
};
</script>

ooo
